const actions = {
  REQUIREMENT_ADD_BEGIN: 'REQUIREMENT_ADD_BEGIN',
  REQUIREMENT_ADD_SUCCESS: 'REQUIREMENT_ADD_SUCCESS',
  REQUIREMENT_ADD_ERR: 'REQUIREMENT_ADD_ERR',

  REQUIREMENT_UPDATE_BEGIN: 'REQUIREMENT_UPDATE_BEGIN',
  REQUIREMENT_UPDATE_SUCCESS: 'REQUIREMENT_UPDATE_SUCCESS',
  REQUIREMENT_UPDATE_ERR: 'REQUIREMENT_UPDATE_ERR',

  REQUIREMENT_READ_BEGIN: 'REQUIREMENT_READ_BEGIN',
  REQUIREMENT_READ_SUCCESS: 'REQUIREMENT_READ_SUCCESS',
  REQUIREMENT_READ_ERR: 'REQUIREMENT_READ_ERR',
  
  requirementUpdateBegin: () => {
    return {
      type: actions.REQUIREMENT_UPDATE_BEGIN,
    };
  },

  requirementUpdateSuccess: (data) => {
    return {
      type: actions.REQUIREMENT_UPDATE_SUCCESS,
      data,
    };
  },

  requirementUpdateErr: (err) => {
    return {
      type: actions.REQUIREMENT_UPDATE_ERR,
      err,
    };
  },

  requirementAddBegin: () => {
    return {
      type: actions.REQUIREMENT_ADD_BEGIN,
    };
  },

  requirementAddSuccess: (data) => {
    return {
      type: actions.REQUIREMENT_ADD_SUCCESS,
      data,
    };
  },

  requirementAddErr: (err) => {
    return {
      type: actions.REQUIREMENT_ADD_ERR,
      err,
    };
  },

  requirementReadBegin: () => {
    return {
      type: actions.REQUIREMENT_READ_BEGIN,
    };
  },

  requirementReadSuccess: (data) => {
    return {
      type: actions.REQUIREMENT_READ_SUCCESS,
      data,
    };
  },

  requirementReadErr: (err) => {
    return {
      type: actions.REQUIREMENT_READ_ERR,
      err,
    };
  },
      
};

export default actions;
